<template>
  <div class="position-wrap mt8" @click.stop>
    <ul class="mb8 verticallyCenter quick-sites-wrap">
      <li v-for="(site, index) in defaultSite" :key="index" class="quick-sites" @click="changeQuickSite(site)">
        <el-tooltip class="item" :hide-after="1000" effect="dark" :content="site.label" placement="top">
          <span class="quick-sites-item">
            <span class="quick-sites-dot" :style="getSiteStyle(site)"></span>
          </span>
        </el-tooltip>
      </li>
    </ul>
    <svg
      v-if="leftType === '%' && topType === '%'"
      width="228"
      height="80"
      viewBox="0 0 228 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        @click="changeSite('bottomVal', 2, -10)"
        d="M4 80H224C224.919 80 225.766 79.6904 226.441 79.1689L168 48H60L1.55859 79.1689C2.23413 79.6904 3.08081 80 4 80Z"
        fill="#F0F0F0"
      />
      <text class="svg-text" x="105" y="70" fill="rgba(0, 0, 0, 0.8)">
        {{ offsetVal[2] == 0 ? "自动" : offsetVal[2] }}
      </text>
      <path
        @click="changeSite('rightVal', 1, 15)"
        d="M228 76V4C228 2.70996 227.389 1.5625 226.441 0.831055L168 32V48L226.441 79.1689C227.389 78.4375 228 77.29 228 76Z"
        fill="#EAEAEA"
      />
      <text class="svg-text" x="185" y="45" fill="rgba(0, 0, 0, 0.8)">
        {{ offsetVal[1] == 0 ? "自动" : offsetVal[1] }}
      </text>
      <path
        @click="changeSite('topVal', 0, 30)"
        d="M226.441 0.831055L168 32H60L1.55859 0.831055C2.23413 0.30957 3.08081 0 4 0H224C224.919 0 225.766 0.30957 226.441 0.831055Z"
        fill="#F0F0F0"
      />
      <text class="svg-text" x="105" y="20" fill="rgba(0, 0, 0, 0.8)">
        {{ offsetVal[0] == 0 ? "自动" : offsetVal[0] }}
      </text>
      <path
        @click="changeSite('leftVal', 3, 15)"
        d="M1.55859 0.831055L60 32V48L1.55859 79.1689C0.610596 78.4375 0 77.29 0 76V4C0 2.70996 0.610596 1.5625 1.55859 0.831055Z"
        fill="#EAEAEA"
      />
      <text class="svg-text" x="15" y="45" fill="rgba(0, 0, 0, 0.8)">
        {{ offsetVal[3] == 0 ? "自动" : offsetVal[3] }}
      </text>
    </svg>
    <div class="site-settings" v-show="showSiteSetting" :style="'margin-top:' + marginTop">
      <slider-and-input class="mb6" :value.sync="inputNum" titlePosition="allInOneLine" suffix="px" />
      <div class="verticallyCenter site-selects">
        <div class="flex1 verticallyCenter site-nums">
          <div class="site-select" v-for="item in defaultPos" @click="changeSiteNum(item)">{{ item }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { withMethodsHistoryCombine } from "utils/revork"
export default withMethodsHistoryCombine({
  name: "position-set",
  data() {
    return {
      inputNum: 0,
      marginTop: 0,
      showSiteSetting: false,
      activeDirection: "",
      activeDirectionIndex: undefined,
      defaultPos: [0, 10, 20, 40, 50, 60, 80, 100],
      defaultSite: [
        {
          label: "顶部居左",
          top: "0%",
          left: "0%",
          rectTop: 0,
          rectLeft: 0,
          rectMargin: [0, 0, 0, 0]
        },
        {
          label: "顶部居中",
          top: "0%",
          left: "50%",
          translate: "(-50%,0)",
          rectTop: 0,
          rectLeft: 50,
          rectMargin: [0, 0, 0, "-50%"]
        },
        {
          label: "顶部居右",
          top: "0%",
          right: "0%",
          rectTop: 0,
          rectLeft: 100,
          rectMargin: [0, 0, 0, "-100%"]
        },
        {
          label: "右侧居中",
          top: "50%",
          right: "0%",
          translate: "(0,-50%)",
          rectTop: 50,
          rectLeft: 100,
          rectMargin: ["-50%", 0, 0, "-100%"]
        },
        {
          label: "底部居右",
          bottom: "0%",
          right: "0%",
          rectTop: 100,
          rectLeft: 100,
          rectMargin: ["-100%", 0, 0, "-100%"]
        },
        {
          label: "底部居中",
          left: "50%",
          bottom: "0%",
          translate: "(-50%,0)",
          rectTop: 100,
          rectLeft: 50,
          rectMargin: ["-100%", 0, 0, "-50%"]
        },
        {
          label: "底部居左",
          left: "0%",
          bottom: "0%",
          rectTop: 100,
          rectLeft: 0,
          rectMargin: ["-100%", 0, 0, 0]
        },
        {
          label: "左侧居中",
          left: "0%",
          top: "50%",
          translate: "(0,-50%)",
          rectTop: 50,
          rectLeft: 0,
          rectMargin: ["-50%", 0, 0, 0]
        },
        {
          label: "中心",
          left: "50%",
          top: "50%",
          translate: "(-50%,-50%)",
          rectTop: 50,
          rectLeft: 50,
          rectMargin: ["-50%", 0, 0, "-50%"]
        }
      ]
    }
  },
  props: {
    left: {
      type: [String, Number]
    },
    top: {
      type: [String, Number]
    },
    margin: {
      type: null
    },
    offset: {
      type: null
    },
    leftType: {
      type: null
    },
    topType: {
      type: null
    }
  },
  watch: {
    inputNum(newVal, oldVal) {
      if (newVal == oldVal) {
        return
      }
      this.offsetVal[this.activeDirectionIndex] = newVal
      let newOffset = [...this.offsetVal]
      newOffset[this.activeDirectionIndex] = newVal
      switch (this.activeDirection) {
        case "leftVal":
          this.$set(newOffset, 1, 0)
          break
        case "rightVal":
          this.$set(newOffset, 3, 0)
          break
        case "topVal":
          this.$set(newOffset, 2, 0)
          break
        case "bottomVal":
          this.$set(newOffset, 0, 0)
          break
      }
      this.offsetVal = newOffset
    }
  },
  computed: {
    leftVal: {
      get() {
        return this.left
      },
      set(newVal) {
        this.$emit("update:left", newVal)
      }
    },
    topVal: {
      get() {
        return this.top
      },
      set(newVal) {
        this.$emit("update:top", newVal)
      }
    },
    marginVal: {
      get() {
        return this.margin || ["auto", "auto", "auto", "auto"]
      },
      set(newVal) {
        this.$emit("update:margin", newVal)
      }
    },
    offsetVal: {
      get() {
        return this.offset || [0, 0, 0, 0]
      },
      set(newVal) {
        this.$emit("update:offset", newVal)
      }
    },
    getSiteStyle() {
      return function (item) {
        return {
          left: item.left,
          right: item.right,
          top: item.top,
          bottom: item.bottom,
          transform: `translate${item.translate}`
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.closeDialog()
    })
  },
  beforeDestroy() {
    document.getElementsByClassName("right-toolbar")[0]?.removeEventListener("click", this.closeSiteSetting)
    document.getElementsByClassName("edit_stage")[0]?.removeEventListener("click", this.closeSiteSetting)
  },
  methods: {
    // 选择快捷位置
    changeQuickSite(site) {
      this.leftVal = site.rectLeft
      this.topVal = site.rectTop
      this.marginVal = site.rectMargin
      this.offsetVal = [0, 0, 0, 0]
    },
    changeSite(name, index, marginTop) {
      this.inputNum = this.offsetVal[index]
      this.activeDirectionIndex = index
      this.marginTop = -marginTop + "px"
      this.showSiteSetting = true
      this.activeDirection = name
    },
    changeSiteNum(val) {
      this.inputNum = val
    },
    // 点击其他区域 关闭弹框
    closeDialog() {
      document.getElementsByClassName("right-toolbar")[0]?.addEventListener("click", this.closeSiteSetting)
      document.getElementsByClassName("edit_stage")[0]?.addEventListener("click", this.closeSiteSetting)
    },
    closeSiteSetting() {
      this.showSiteSetting = false
    }
  }
})
</script>

<style lang="scss" scoped>
.position-wrap {
  position: relative;
  overflow: visible;
  z-index: 999;
}
path {
  cursor: pointer;
}
path:hover {
  fill: #e3e3e3;
}
.svg-text {
  pointer-events: none;
  cursor: pointer;
}
.w56 {
  width: 56px;
  height: 56px;
  line-height: 56px;
}
.site-selects .item {
  margin: 0 2px;
}
.site-selects .item:first-child {
  margin-left: 0;
}
.site-selects .item:last-child {
  margin-right: 0;
}
.site-select {
  background: #f3f3f3;
  border-radius: 4px;
  margin: 2px 0;
  text-align: center;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.8);
  &:hover {
    background-color: #ebebeb;
  }
  &:active {
    background-color: rgba(0, 0, 0, 0.12);
  }
}
.site-settings {
  position: absolute;
  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 8px 20px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  z-index: 2;
  border: 1px solid #e9e9e9;
  background-color: #fff;
  padding: 12px;
  box-sizing: border-box;
  width: 100%;
}
.mb6 {
  margin-bottom: 6px;
}
.site-nums {
  flex-wrap: wrap;
  justify-content: space-around;
}
.site-nums .site-select {
  width: calc(25% - 4px);
  height: 26px;
}
.quick-sites-wrap {
  justify-content: space-between;
}
.quick-sites {
  border-radius: 2px;
  width: 20px;
  height: 20px;
  text-align: center;
  &:hover {
    background: rgba(31, 35, 41, 0.08);
  }
  &:active {
    background: rgba(0, 0, 0, 0.12);
  }
}
.quick-sites-item {
  position: relative;
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 1px;
  .quick-sites-dot {
    position: absolute;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 1px;
    display: inline-block;
    width: 6px;
    height: 6px;
    content: "";
  }
}
.position-select {
  background: #f3f3f3;
  border-radius: 4px;
  height: 32px;
  padding: 0 13px;
  box-sizing: border-box;
  cursor: pointer;
  .icon {
    width: 20px;
    pointer-events: none;
    transition: transform 0.3s;
    transform-origin: center center;
    &.rotate180 {
      transform: rotate(180deg);
    }
  }
  .text-right {
    font-size: 16px;
    width: 16px;
    text-align: right;
  }
}
.position-selects-wrap {
  //position: absolute;
  //margin-top: 4px;
  //top:32px;
  width: 228px;
  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 8px 20px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  border: 1px solid #dee0e3;
  padding: 4px 0;
  z-index: 9999;
  //width: 100%;
  background-color: #fff;
  .position-select-item {
    padding: 0 12px;
    height: 38px;
    line-height: 38px;
    box-sizing: border-box;
    width: 100%;
    cursor: pointer;
    .icon {
      margin-right: 9px;
    }
    &:hover {
      background-color: #f0f2f7;
    }
  }
  .icon-img {
    display: inline-block;
    width: 16px;
    height: 16px;
    background-size: 100% 100%;
  }
  .icon-img.icon-absolute {
    background-image: url("../../../assets/images/absolute.png");
  }
  .icon-img.icon-fixed {
    background-image: url("../../../assets/images/fixed.png");
  }
}
.position-info {
  position: relative;
  padding: 12px 12px 12px 24px;
  box-sizing: border-box;
  border-top: 1px solid #e8e8e8;
  &:before {
    position: absolute;
    top: 12px;
    bottom: 12px;
    left: 11px;
    width: 2px;
    content: "";
    background-color: rgba(43, 103, 255, 0.5);
  }
}
.position-select-set {
  position: relative;
}
.position-select-dropdown {
  width: 100%;
}
</style>
